'use strict';

exports.__esModule = true;
exports.default = undefined;

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _Cabecera = require('./Cabecera');

var _Cabecera2 = _interopRequireDefault(_Cabecera);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ScrollPanel = require('primereact/components/scrollpanel/ScrollPanel');

var _MenuPrincipal = require('./MenuPrincipal');

var _MenuPrincipal2 = _interopRequireDefault(_MenuPrincipal);

var _ApiRest = require('../api/ApiRest');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _datosLocalesHelper2 = require('../helpers/datosLocalesHelper');

var _menuHelper = require('../helpers/menuHelper');

var _nodeConstantesSeps = require('node-constantes-seps');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Layout = (_temp = _class = function (_Component) {
  _inherits(Layout, _Component);

  function Layout(props) {
    _classCallCheck(this, Layout);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      layoutMode: 'static',
      layoutCompact: true,
      overlayMenuActive: false,
      staticMenuDesktopInactive: props.staticMenuDesktopInactive,
      staticMenuMobileActive: false,
      rotateMenuButton: false,
      topbarMenuActive: false,
      activeTopbarItem: null,
      darkMenu: false,
      menuActive: false,
      theme: 'blue',
      layout: 'blue',
      version: 'v4',
      activarMenuPrincipal: props.activarMenuPrincipalitems,
      menu: null,
      sinPermisos: false
    };
    _this.onDocumentClick = _this.onDocumentClick.bind(_this);
    _this.onMenuClick = _this.onMenuClick.bind(_this);
    _this.onMenuButtonClick = _this.onMenuButtonClick.bind(_this);
    _this.onTopbarMenuButtonClick = _this.onTopbarMenuButtonClick.bind(_this);
    _this.onTopbarItemClick = _this.onTopbarItemClick.bind(_this);
    _this.onMenuItemClick = _this.onMenuItemClick.bind(_this);
    _this.onRootMenuItemClick = _this.onRootMenuItemClick.bind(_this);
    return _this;
  }

  Layout.prototype.componentWillMount = function componentWillMount() {
    if (this.props.menu) {
      this.createMenu();
    }

    setInterval(function () {
      var now = Date.now().valueOf() / 1000;
      console.log('entro al interval');
      var identificadorSesion = (0, _datosLocalesHelper2.datosLocalesHelper)();

      if (identificadorSesion) {
        console.log('entro al interval 2');

        if (identificadorSesion['tokenSeps'].exp < now) {
          console.log('entro al interval 3');
          this.setState({
            sinPermisos: true
          });
        }
      }
    }, 900000);
  };

  Layout.prototype.onMenuClick = function onMenuClick(event) {
    this.menuClick = true;
    /*if(!this.isHorizontal()) {
        setTimeout(() => {this.layoutMenuScroller.moveBar(); }, 500);
    }*/
  };

  Layout.prototype.onMenuButtonClick = function onMenuButtonClick(event) {
    this.menuClick = true;
    this.setState({
      rotateMenuButton: !this.state.rotateMenuButton,
      topbarMenuActive: false
    });

    if (this.state.layoutMode === 'overlay') {
      this.setState({
        overlayMenuActive: !this.state.overlayMenuActive
      });
    } else {
      if (this.isDesktop()) this.setState({
        staticMenuDesktopInactive: !this.state.staticMenuDesktopInactive
      });else this.setState({
        staticMenuMobileActive: !this.state.staticMenuMobileActive
      });
    }

    event.preventDefault();
  };

  Layout.prototype.onTopbarMenuButtonClick = function onTopbarMenuButtonClick(event) {
    this.topbarItemClick = true;
    this.setState({
      topbarMenuActive: !this.state.topbarMenuActive
    });
    this.hideOverlayMenu();
    event.preventDefault();
  };

  Layout.prototype.onTopbarItemClick = function onTopbarItemClick(event) {
    this.topbarItemClick = true;
    if (this.state.activeTopbarItem === event.item) this.setState({
      activeTopbarItem: null
    });else this.setState({
      activeTopbarItem: event.item
    });
    event.originalEvent.preventDefault();
  };

  Layout.prototype.onMenuItemClick = function onMenuItemClick(event) {
    if (!event.item.items) {
      this.hideOverlayMenu();
    }

    if (!event.item.items && this.isHorizontal()) {
      this.setState({
        menuActive: false
      });
    }
  };

  Layout.prototype.onRootMenuItemClick = function onRootMenuItemClick(event) {
    this.setState({
      menuActive: !this.state.menuActive
    });
    event.originalEvent.preventDefault();
  };

  Layout.prototype.onDocumentClick = function onDocumentClick(event) {
    if (!this.topbarItemClick) {
      this.setState({
        activeTopbarItem: null,
        topbarMenuActive: false
      });
    }

    if (!this.menuClick) {
      if (this.isHorizontal() || this.isSlim()) {
        this.setState({
          menuActive: false
        });
      }

      this.hideOverlayMenu();
    }

    if (!this.rightPanelClick) {
      this.setState({
        rightPanelActive: false
      });
    }

    this.topbarItemClick = false;
    this.menuClick = false;
    this.rightPanelClick = false;
  };

  Layout.prototype.hideOverlayMenu = function hideOverlayMenu() {
    this.setState({
      rotateMenuButton: false,
      overlayMenuActive: false,
      staticMenuMobileActive: false
    });
  };

  Layout.prototype.isTablet = function isTablet() {
    var width = window.innerWidth;
    return width <= 1024 && width > 640;
  };

  Layout.prototype.isDesktop = function isDesktop() {
    return window.innerWidth > 1024;
  };

  Layout.prototype.isMobile = function isMobile() {
    return window.innerWidth <= 640;
  };

  Layout.prototype.isOverlay = function isOverlay() {
    return this.state.layoutMode === 'overlay';
  };

  Layout.prototype.isHorizontal = function isHorizontal() {
    return this.state.layoutMode === 'horizontal';
  };

  Layout.prototype.isSlim = function isSlim() {
    return this.state.layoutMode === 'slim';
  };

  Layout.prototype.createMenu = function createMenu() {
    var _this2 = this;

    if (!this.state.menu) {
      var _datosLocalesHelper = (0, _datosLocalesHelper2.datosLocalesHelper)(),
          tokenSeps = _datosLocalesHelper.tokenSeps,
          sistemaSeps = _datosLocalesHelper.sistemaSeps,
          orgSeps = _datosLocalesHelper.orgSeps;

      try {
        var urlMenu = _nodeConstantesSeps.API_ROOT + '/sca/acceso/menu-usuario/usuario/' + tokenSeps.idusuario + '/subsistema/' + sistemaSeps.codSistema + '/organizacion-usuario/0';

        if (orgSeps) {
          urlMenu = _nodeConstantesSeps.API_ROOT + '/sca/acceso/menu-usuario/usuario/' + tokenSeps.idusuario + '/subsistema/' + sistemaSeps.codSistema + '/organizacion-usuario/' + orgSeps.codOrganizacionUsuario;
        }

        _ApiRest.ApiRest.get(urlMenu).then(function (menuarray) {
          _this2.setState({
            menu: (0, _menuHelper.menuHelper)(menuarray)
          });
        }, function (error) {
          _this2.setState({
            sinPermisos: true
          });

          console.log('error de fetch', error);
        });
      } catch (error) {
        console.log('error de try', error);
      }
    }
  };

  Layout.prototype.render = function render() {
    var _this3 = this;

    var layoutClassName = (0, _classnames2.default)('layout-wrapper', {
      'menu-layout-static': this.state.layoutMode !== 'overlay',
      'menu-layout-overlay': this.state.layoutMode === 'overlay',
      'layout-menu-overlay-active': this.state.overlayMenuActive,
      'menu-layout-slim': this.state.layoutMode === 'slim',
      'menu-layout-horizontal': this.state.layoutMode === 'horizontal',
      'layout-menu-static-inactive': this.state.staticMenuDesktopInactive,
      'layout-menu-static-active': this.state.staticMenuMobileActive
    });
    var menuClassName = (0, _classnames2.default)('layout-menu-container', {
      'layout-menu-dark': this.state.darkMenu
    });

    if (this.state.sinPermisos) {
      return _react2.default.createElement(_reactRouterDom.Redirect, {
        to: '/login'
      });
    } else {
      return _react2.default.createElement('div', {
        className: layoutClassName
      }, _react2.default.createElement(_Cabecera2.default, {
        topbarMenuActive: this.state.topbarMenuActive,
        activeTopbarItem: this.state.activeTopbarItem,
        onMenuButtonClick: this.onMenuButtonClick,
        onTopbarMenuButtonClick: this.onTopbarMenuButtonClick,
        onTopbarItemClick: this.onTopbarItemClick,
        activarMenuPrincipal: this.props.activarMenuPrincipal
      }), this.state.menu && _react2.default.createElement('div', {
        className: menuClassName,
        onClick: this.onMenuClick
      }, _react2.default.createElement(_ScrollPanel.ScrollPanel, {
        ref: function ref(el) {
          return _this3.layoutMenuScroller = el;
        },
        style: {
          height: '100%'
        }
      }, _react2.default.createElement('div', {
        className: 'menu-scroll-content'
      }, _react2.default.createElement(_MenuPrincipal2.default, {
        model: this.state.menu,
        onMenuItemClick: this.onMenuItemClick,
        onRootMenuItemClick: this.onRootMenuItemClick,
        layoutMode: this.state.layoutMode,
        active: this.state.menuActive
      })))), _react2.default.createElement('div', {
        className: 'layout-main'
      }, this.props.body));
    }
  };

  return Layout;
}(_react.Component), _class.defaultProps = {
  staticMenuDesktopInactive: true,
  activarMenuPrincipal: false,
  menu: false
}, _temp);
exports.default = Layout;
Layout.propTypes = process.env.NODE_ENV !== "production" ? {
  staticMenuDesktopInactive: _propTypes2.default.bool,
  activarMenuPrincipalitems: _propTypes2.default.bool,
  menu: _propTypes2.default.bool
} : {};
module.exports = exports['default'];